import { authInstance } from './axios';
import { filterParams } from '../assets/helpers/funciones';
let url = process.env.REACT_APP_API_URL;

export const casheaLinkService = {
  getPayPlan: async (identification, price) => {
    const response = await authInstance
      .get(
        `${url}/payments/casheaLinkPayPlan?identification=${identification}&price=${price}`
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  confirmInitialPay: async (membershipId, data) => {
    const response = await authInstance
      .put(`${url}/memberships/confirmCasheaLinkInitialPay/${membershipId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listDeletedOrders: async (params) => {
    const response = await authInstance
      .get(
        `${url}/casheaLinkDeletedOrders/list?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
